import React from 'react';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { Link } from 'react-router-dom';
import AttachmentsLightBox from './AttachmentsLightBox';
import { Icon } from '@progress/kendo-react-common';
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { Skeleton } from '@progress/kendo-react-indicators';

//Create a type that extends ITicketProps
interface IAttachmentsProps extends ITicketProps {
    editMode: boolean;
}

const Attachments: React.FC<IAttachmentsProps> = ({ editMode, Is_Loading }) => {
    const [count, setCount] = React.useState(0);

    return (
        <Card className={(count == 0 && !editMode) ? 'sidebar-attachments hidden' : 'sidebar-attachments'}>
            <CardHeader>
                <Icon size='large' name='paperclip' /><Link className='nav-link' to='files' title='View attachments'>{count} Attachments</Link>

                <Link to='files' className='nav-link ownership-menu-button' title='View attachments'><Button svgIcon={svg.hyperlinkOpenIcon}></Button></Link>

            </CardHeader>
            <CardBody>
                {Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '50px', marginTop: '2px' }} /> :
                    <AttachmentsLightBox showPaging={false} gotAttachments={(a) => setCount(a.length)} />}
            </CardBody>
        </Card>
    );
};

export default Attachments;